import React from 'react';
import { Link } from 'react-router-dom';
import { Button, Dialog, DialogActions, DialogTitle, Slide } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { trackEventMatomo } from 'js/library/utils/helpers';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function LoginModal(props) {
  const { t } = useTranslation('app');

  const { openState, setOpenState } = props;

  const handleClose = () => {
    trackEventMatomo(document.title, 'tocar', 'Modal anonimo', 'Agora não');
    setOpenState(false);
  };

  const loginUser = () => {
    trackEventMatomo(document.title, 'tocar', 'Modal anonimo', 'Continuar');
    localStorage.setItem('loginOption', '3');
    localStorage.setItem('loginRedirect', document.location.href);
  };

  return (
    <Dialog
      open={openState}
      TransitionComponent={Transition}
      keepMounted
      onClose={() => {
        handleClose();
      }}
      aria-labelledby="alert-dialog-slide-title"
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogTitle id="alert-dialog-slide-title">{t('general.we_take_care_of_you')}</DialogTitle>

      <DialogActions style={{ alignSelf: 'center' }}>
        <Button
          variant="contained"
          onClick={handleClose}
          color="secondary"
          style={{ marginRight: '5px' }}
        >
          {t('general.not_now')}
        </Button>

        <Link onClick={() => loginUser()} to="/login" style={{ textDecoration: 'none' }}>
          <Button onClick={handleClose} variant="contained" color="primary">
            {t('general.continue')}
          </Button>
        </Link>
      </DialogActions>
    </Dialog>
  );
}
